"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
exports.sizes = {
    0: "w-0 h-0",
    xs: "w-8 h-8",
    sm: "w-12 h-12",
    base: "w-14 h-14",
    md: "w-16 h-16",
    lg: "w-20 h-20",
    xl: "w-24 h-24",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2l6ZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc3R5bGVzL2NvbmZpZ3Mvc2l6ZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxLQUFLLEdBQWlDO0lBQ2pELENBQUMsRUFBRSxTQUFTO0lBQ1osRUFBRSxFQUFFLFNBQVM7SUFDYixFQUFFLEVBQUUsV0FBVztJQUNmLElBQUksRUFBRSxXQUFXO0lBQ2pCLEVBQUUsRUFBRSxXQUFXO0lBQ2YsRUFBRSxFQUFFLFdBQVc7SUFDZixFQUFFLEVBQUUsV0FBVztDQUNoQixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQmVhdXRpZnlTaXplIH0gZnJvbSBcIkBzcmMvdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHNpemVzOiBSZWNvcmQ8QmVhdXRpZnlTaXplLCBzdHJpbmc+ID0ge1xuICAwOiBcInctMCBoLTBcIixcbiAgeHM6IFwidy04IGgtOFwiLFxuICBzbTogXCJ3LTEyIGgtMTJcIixcbiAgYmFzZTogXCJ3LTE0IGgtMTRcIixcbiAgbWQ6IFwidy0xNiBoLTE2XCIsXG4gIGxnOiBcInctMjAgaC0yMFwiLFxuICB4bDogXCJ3LTI0IGgtMjRcIixcbn07XG4iXX0=